import React from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { useDispatch } from 'react-redux'

import styles from './styles.module.scss'

import { showPrintLabel } from '../../../store/asset/actions'

import QRCode from '../QRCode'
import { PrintIcon } from '../Icons'

const AssetOverview = ({asset}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handlePrintLabel = () => {
    dispatch(showPrintLabel(asset))
  }

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.sectionTitle}>{t('Responsibility')}</div>
        <div className={styles.sectionContent}>
          <div className={styles.sectionContentItem}>
            <div className={styles.sectionContentItemTitle}>{t('Assigned to')}</div>
            <div className={styles.sectionContentItemValue}>{asset.employee ? `${asset.employee.name} ${asset.employee.surname}` : t('Unassigned')}</div>
          </div>
          <div className={styles.sectionContentItem}>
            <div className={styles.sectionContentItemTitle}>{t('Current project')}</div>
            <div className={styles.sectionContentItemValue}>{asset.place ? asset.place.name : '-'}</div>
          </div>
          <div className={styles.sectionContentItem}>
            <div className={styles.sectionContentItemTitle}>{t('Current location')}</div>
            <div className={styles.sectionContentItemValue}>{asset.location || '-'}</div>
          </div>
        </div>
      </div>
      <div className={styles.section}>
        <div className={styles.sectionTitle}>{t('Last known location')}</div>
        <div className={styles.sectionContent}>
        </div>
      </div>
      <div className={styles.section}>
        <div className={styles.sectionTitle}>{t('Inspections')}</div>
        <div className={styles.sectionContent}>
        </div>
      </div>
      <div className={styles.section}>
        <div className={styles.sectionTitle}>{t('Identity')}</div>
        <div className={styles.sectionContent}>
          <div className={styles.sectionContentItem}>
            <div className={styles.sectionContentItemTitle}>{t('Serial number')}</div>
            <div className={styles.sectionContentItemValue}>{asset.details?.serial_number || '-'}</div>
          </div>
          <div className={styles.qrCodeContainer}>
            <QRCode value={`${window.location.origin}/scan/assets/${asset.qr_code_data}`} size={56} />
            <div className={styles.printActions}>
              <button type="button" className={styles.printButton} onClick={handlePrintLabel}>
                <PrintIcon />
                {t('Print label')}
              </button>
            </div>
          </div>
          <div className={styles.sectionContentItem}>
            <div className={styles.sectionContentItemTitle}>{t('Manufacturer')}</div>
            <div className={styles.sectionContentItemValue}>{asset.details?.manufacturer || '-'}</div>
          </div>
          <div className={styles.sectionContentItem}>
            <div className={styles.sectionContentItemTitle}>{t('Model')}</div>
            <div className={styles.sectionContentItemValue}>{asset.details?.model || '-'}</div>
          </div>
          <div className={styles.sectionContentItem}>
            <div className={styles.sectionContentItemTitle}>{t('Condition')}</div>
            <div className={styles.sectionContentItemValue}>{asset.details?.condition}</div>
          </div>
          <div className={styles.sectionContentItem}>
            <div className={styles.sectionContentItemTitle}>{t('Warranty expiration')}</div>
            <div className={styles.sectionContentItemValue}>{asset.warranty_expiration ? moment(asset.warranty_expiration).format('YYYY-MM-DD') : '-'}</div>
          </div>
          <div className={styles.sectionContentItem}>
            <div className={styles.sectionContentItemTitle}>{t('Supplier')}</div>
            <div className={styles.sectionContentItemValue}>{asset.supplier || '-'}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AssetOverview
